
// DEPRECATED. DON'T USE.

export const PaymentPreference = {
  Maintenance: 'Maintenance',
  Rent: 'Rent',
  Payout: 'Payout',
  RentalHomeInsurance: 'RentalHomeInsurance',
};

export const PaymentPriority = {
  Primary: 'Primary',
  Backup: 'Backup',
};

export const ReportType = {
  Improvements: 'Improvements',
  Pricing: 'Pricing',
  ImprovementsSpecialist: 'ImprovementsSpecialist',
} as const;

// 'Other' means none of the current regions, which is different from null, which means closed by X
